import { useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "offerings", label: "What I Offer" },
  { id: "highlights", label: "Highlights" },
  { id: "contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-[#E2D9CC] bg-[#FAF7F2]/85 backdrop-blur-md"
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:h-20 sm:px-6 lg:px-8">
        <button
          data-testid="nav-brand-button"
          onClick={() => go("home")}
          className="flex items-center gap-3 font-display text-base font-bold tracking-[0.14em] text-[#1C1B1A] sm:text-lg"
        >
          <img
            data-testid="nav-brand-logo"
            src="/saath-logo.png"
            alt="SAATH Trainings logo"
            className="h-10 w-10 rounded-full object-contain sm:h-12 sm:w-12"
          />
          <span>
            SAATH TRAININGS
          </span>
        </button>

        <nav data-testid="desktop-nav" className="hidden items-center gap-7 md:flex">
          {LINKS.slice(0, 4).map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="link-underline py-1 text-sm font-medium text-[#524E48] transition-colors hover:text-[#1C1B1A]"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-contact-me-button"
            onClick={() => go("contact")}
            className="rounded-full bg-[#1C1B1A] px-5 py-2.5 text-sm font-semibold text-[#FAF7F2] transition-colors duration-300 hover:bg-[#E05A10]"
          >
            Contact Me
          </button>
        </nav>

        <button
          data-testid="mobile-menu-button"
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation menu"
          className="flex h-11 w-11 items-center justify-center rounded-full border border-[#E2D9CC] text-[#1C1B1A] md:hidden"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="mobile-nav"
          className="border-t border-[#E2D9CC] bg-[#FAF7F2] px-4 pb-6 pt-2 md:hidden"
        >
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="block w-full border-b border-[#EFE8DC] py-4 text-left font-display text-xl font-bold text-[#1C1B1A]"
            >
              {l.label}
            </button>
          ))}
        </nav>
      )}
    </header>
  );
}
